const data = [
    {
        key: '1',
        projectName: { text: 'Hệ thống nguồn' },
        product: { text: 'Điều khiển động cơ servo, có thể xuất khoảng cách lực ở tốc độ thấp, độ chính xác định vị cao, lên đến cấp độ micron.' },
        other: { text: 'Biến tần và động cơ thông thường, chế độ điều khiển V/F, khoảng cách lực nhỏ ở tốc độ thấp, độ chính xác định vị không cao, chỉ đến cấp độ centimet.' }
    },
    {
        key: '2',
        projectName: { text: 'Thiết bị đệm vải' },
        product: { text: 'Rãnh V sâu, bộ đệm vải lớn, giải phóng hoàn toàn lực căng, độ đàn hồi vừa phải.' },
        other: { text: 'Rãnh V nông, bộ đệm vải nhỏ, lực căng không đều ở tốc độ cao.' }
    },
    {
        key: '3',
        projectName: { text: 'Thiết bị xả vải' },
        product: { text: 'Máy tính vi điều khiển tự động tính toán rằng cảm biến quang điện tự động cấp vải.' },
        other: { text: 'Đặt thông số thủ công, khó vận hành cho người mới.' }
    },
    {
        key: '4',
        projectName: { text: 'Thiết bị san phẳng công suất' },
        product: { text: 'Sản phẩm được cấp bằng sáng chế san phẳng vải và cho phép kéo ra khỏi mép vải cuộn, có lợi cho mặt đối diện, hiệu quả đối với vải dệt kim rõ ràng, được sử dụng rộng rãi trong vải dệt kim.' },
        other: { text: 'Không có' }
    },
    {
        key: '5',
        projectName: { text: 'Thiết bị sang hai bên' },
        product: { text: 'Cảm biến quang điều khiển tự động đường biên PLC, mạch đơn giản, độ nhạy có thể điều chỉnh được.' },
        other: { text: 'Điều khiển relay, mạch phức tạp, khó bảo trì.' }
    },
    {
        key: '6',
        projectName: { text: 'Thiết bị cấp vải' },
        product: { text: 'Điều khiển động cơ servo, hệ thống theo dõi thời gian thực, đồng bộ hóa điện tử, lực căng cấp vải đồng đều.' },
        other: { text: 'Đồng bộ hóa cơ khí bằng xích và đĩa xích, xích dễ tạo ren và mảnh vụn. Sau thời gian vận hành dài, xích sẽ bị lỏng, gây lỏng vải. Cấu trúc phức tạp và khó bảo trì.' }
    },
    {
        key: '7',
        projectName: { text: 'Thiết bị theo dõi tự động đàn hồi' },
        product: { text: 'Cảm biến quang giám sát độ đàn hồi của vải theo thời gian thực, có thể tự động điều chỉnh độ lỏng khi siết chặt và tự động điều chỉnh lực căng khi lỏng.' },
        other: { text: 'Không có' }
    },
    {
        key: '8',
        projectName: { text: 'Bộ nhớ vải' },
        product: { text: 'Dữ liệu của 30 loại vải có thể lưu dữ liệu của vải đã trải. Người dùng có thể gọi lại tên vải đã lưu trước đó mà không cần đặt lại, tiện lợi và thực dụng.' },
        other: { text: 'Không thể nhớ, không có chức năng này.' }
    },
    {
        key: '9',
        projectName: { text: 'Hiệu quả trải vải' },
        product: { text: 'Phẳng, căn chỉnh tốt, đàn hồi, độ căng tốt và phù hợp với nhiều loại vải đa dạng.' },
        other: { text: 'Thỉnh thoảng không đều, không có nhiều loại vải phù hợp. Không thể áp dụng cho vải đàn hồi cao, mỏng nhẹ và cuộn mép.' }
    }
];

export default data;
